import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../util/ErrorAdd";


function ModalRemove({ model, show, onHide, onHideMain }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    //Событие закрытия/открытия модального окна.
    useEffect(() => {
        if (show === true) {

        }
    }, [show]);

    //Отправка формы
    function removeHandler() {
        setLoading(true);

        axios.post('/api_tracker/project/remove', { ID_Project: model.ID })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    onHide();
                    onHideMain();
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }


    return (
        <>
            <Modal show={show} onHide={onHide} size="md">
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Удаление проекта</div>
                    Подтвердите удаление проекта <b>«{model.Name_Full}»</b>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="remove" loading={loading} size={'lg'} onClick={() => removeHandler()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default ModalRemove;
